var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99982 3.44482C11.7614 3.44482 13.414 4.14379 14.6349 5.36473C14.8552 5.585 15.0592 5.82024 15.2455 6.06848L15.2438 4.75582C15.2438 4.41966 15.4969 4.14259 15.8229 4.10473L15.8993 4.10032C16.2355 4.10032 16.5126 4.35338 16.5504 4.67939L16.5548 4.75582V8.03332C16.5548 8.36949 16.3018 8.64656 15.9758 8.68442L15.8993 8.68882H12.6218C12.2598 8.68882 11.9663 8.39535 11.9663 8.03332C11.9663 7.69716 12.2194 7.42009 12.5454 7.38223L12.6218 7.37782L14.5425 7.37796C14.3134 6.98194 14.0327 6.6166 13.7079 6.29175C12.7304 5.31423 11.4101 4.75582 9.99982 4.75582C7.10364 4.75582 4.75582 7.10364 4.75582 9.99982C4.75582 12.896 7.10364 15.2438 9.99982 15.2438C11.4101 15.2438 12.7304 14.6854 13.7079 13.7079C14.1949 13.2209 14.5825 12.6429 14.8462 12.0069C14.9773 11.6907 15.0772 11.3618 15.144 11.0239C15.2143 10.6688 15.5591 10.4379 15.9142 10.5081C16.2694 10.5784 16.5003 10.9232 16.4301 11.2784C16.3464 11.7013 16.2214 12.1132 16.0572 12.5091C15.7274 13.3045 15.2431 14.0267 14.6349 14.6349C13.414 15.8559 11.7614 16.5548 9.99982 16.5548C6.3796 16.5548 3.44482 13.6201 3.44482 9.99982C3.44482 6.3796 6.3796 3.44482 9.99982 3.44482Z",
    fill: "#737373",
    stroke: "#737373",
    strokeWidth: 0.1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refresh-icon.f5ff14bb4bdf9cc57464ffe39646b405.svg";
export { ForwardRef as ReactComponent };